module.exports = __webpack_public_path__ + "img/steering-wheel.581fb23b.svg";